import axios from "axios";
import { clone } from "ramda";
import { baseUrl } from "..";
function prepareUrl(options, keyId) {
  let url = baseUrl;
  url = url.replace(":company_id", options.companyId);
  return "".concat(url, "/").concat(keyId);
}
export default (axiosConfig, options) => {
  return params => {
    const config = clone(axiosConfig);
    config.method = "DELETE";
    config.url = prepareUrl(options, params.keyId);
    config.data = {
      password: btoa(params.password)
    };
    return axios(config);
  };
};